module.exports = __webpack_public_path__ + "78aaa0b21399ffaa93ef63cb8380c569.png";